"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Basic List Iterator.
 *
 * @author Jeongho Nam <http://samchon.org>
 */

var ListIterator =
/** @class */
function () {
  /* ---------------------------------------------------------------
      CONSTRUCTORS
  --------------------------------------------------------------- */

  /**
   * @hidden
   */
  function ListIterator(prev, next, value) {
    this.prev_ = prev;
    this.next_ = next;
    this.value_ = value;
  }
  /**
   * @internal
   */


  ListIterator._Set_prev = function (it, prev) {
    it.prev_ = prev;
  };
  /**
   * @internal
   */


  ListIterator._Set_next = function (it, next) {
    it.next_ = next;
  };
  /**
   * @inheritDoc
   */


  ListIterator.prototype.prev = function () {
    return this.prev_;
  };
  /**
   * @inheritDoc
   */


  ListIterator.prototype.next = function () {
    return this.next_;
  };

  Object.defineProperty(ListIterator.prototype, "value", {
    /**
     * @inheritDoc
     */
    get: function get() {
      return this.value_;
    },
    enumerable: true,
    configurable: true
  });
  /* ---------------------------------------------------------------
      COMPARISON
  --------------------------------------------------------------- */

  /**
   * @inheritDoc
   */

  ListIterator.prototype.equals = function (obj) {
    return this === obj;
  };

  return ListIterator;
}();

exports.ListIterator = ListIterator;